import { render, staticRenderFns } from "./ShippingOrders.vue?vue&type=template&id=28fff36c&scoped=true"
import script from "./ShippingOrders.vue?vue&type=script&lang=js"
export * from "./ShippingOrders.vue?vue&type=script&lang=js"
import style0 from "./ShippingOrders.vue?vue&type=style&index=0&id=28fff36c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fff36c",
  null
  
)

export default component.exports